import { IPlayerData } from 'src/interfaces/PlayerData';
import { API_EMBED_BASE_URL } from 'src/utils/envUtils';

export const pallyconLicenseEndpoint = (data: IPlayerData, token: string) => (
  `${API_EMBED_BASE_URL}/v1/drm/${data.code}/license?signature=${data.signature}&user=${data.user}&token=${token}`
);